import DeleteIcon from './component.jsx'
export default DeleteIcon
